/**
 * utils.js collects helper functions we can use in our scripts
 */

import $ from 'jquery';

function isUndefined(obj) {
  return typeof obj === 'undefined';
}

function isDefined(obj) {
  return !(isUndefined(obj));
}

function isNumeric(number) {
  if(isUndefined(number)){
    return false;
  }
  return !isNaN(number) && isFinite(number);
}

function numberFormat(num) {
  if (+num % 1 === 0) {
    // dont parse 1.00 or 12.0s
    return ~~num;
  }

  var y = num.toString().split('.');
  if(num > 9999) {y[0] = y[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');}

  return y.join(',');
}

function sortByKey(key, isAsc) {
  if (isUndefined(isAsc)) {
    isAsc = true;
  }

  return (a, b) => {
    if (a[key] < b[key]) {
      return isAsc ? 1 : -1;
    } else if (a[key] > b[key]) {
      return isAsc ? -1 : 1;
    } else {
      return 0;
    }
  }
}

function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length != b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function slugify(str) {
  return str.toLowerCase()
    .replace(/\s/g, '-')
    .replace('ü', 'ue')
    .replace('ä', 'ae')
    .replace('ö', 'oe')
}

// you can use this function if you want an element
// to trigger click only on click and not on swipe
function clickOnly(el) {
  let hasMoved;

  $(el).on('touchend touchstart touchmove', function(e) {
    if(e.type === 'touchstart') {
      hasMoved = false;
    }
    else if(e.type === 'touchmove') {
      hasMoved = true;
    }
    else if(e.type === 'touchend') {
      if(!hasMoved) {
        e.stopPropagation();
        e.preventDefault();
        $(e.target).trigger('click');
      }
    }
  });
}

///////////////////////
/// device detection //
///////////////////////

let oldBrowser, mobile, smartphone, clickEvent, hasPointerEvents, isIE;

function checkPointerEvents() {
  const element = document.createElement('div');
	element.style.cssText = 'pointer-events:auto';
	return element.style.pointerEvents === 'auto';
}

function updateVars() {
  oldBrowser = !(('querySelector' in document) && ('localStorage' in window) && ('addEventListener' in window));
  mobile = !isUndefined(window.orientation);
  smartphone = /android.*mobile|mobile.*android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  clickEvent = mobile ? 'touchstart' : 'click';
  hasPointerEvents = checkPointerEvents();
  isIE = detectIE();
}

function isSmallScreen() {
  return window.innerWidth <= 899;
}

function detectIE() {
  const ua = window.navigator.userAgent;
  return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
}

//////////////////
/// geo helpers //
//////////////////

const geo = {
	berlinCenter : [52.52, 13.4],
	berlinBounds : [[52, 12], [53, 15]],

  geoCode: search => {
    const url = `http://nominatim.openstreetmap.org/search/${search.replace(/\s\d/, ',')}%20Berlin?format=json&addressdetails=1&limit=10&polygon_svg=1`;
    return $.ajax({
      url : url,
      type: 'GET',
      dataType: 'json'
    });
  },

  getZoomByWindowSize: () => {
    let mapZoom = 5;

    if (smartphone || window.innerWidth < 500) {
      mapZoom = 4;
    } else if (window.innerWidth < 768) {
      mapZoom = 5;
    } else if (window.innerWidth < 1100) {
      mapZoom = 5;
    } else if (window.innerWidth > 2000) {
      mapZoom = 6;
    }

    return mapZoom;
  }
}

function trackEvent(name, data) {
  dataLayer.push({
    'event': 'interaktiv_event',
    'name': `interaktiv_${name}`,
    'event_data': data
  });
}

function animateHeadline() {
  $('.intro').addClass('is-animated-headline');
}


updateVars();

export default {
	isUndefined,
  isDefined,
	isNumeric,
	numberFormat,
  debounce,
  arraysEqual,
  clickOnly,
  sortByKey,
  slugify,

	isOldBrowser : oldBrowser,
	isMobile : mobile,
	isSmartphone : smartphone,
  isSmallScreen,
  clickEvent,
  hasPointerEvents,
  isIE,

	updateVars,

	geo,
  trackEvent,
  
  animateHeadline
};
